import { Route, Routes } from 'react-router-dom';
import { Box, Flex } from '@podiumhq/design-system';

import useInitIpqs from 'components/ThirdPartyScripts/hooks/useInitIpqs';
import { TOTAL_STEPS, TRIAL_PAYMENT_STEP } from 'screens/Trials/constants';

import { TrialsPageFooter, TrialsPageHeader } from '../layout';
import useTrialStep from '../hooks/useTrialStep';
import { centerPageViewContentStyles } from '../styles';

import TrialAccountInfo from './TrialAccountInfo';
import TrialPayment from './TrialPayment';

export const TrialPageView = () => {
  const { stepCount } = useTrialStep();
  useInitIpqs(true);

  return (
    <Flex
      boxSizing="border-box"
      direction="column"
      height="100%"
      minHeight="100vh"
      padding="32px 32px 24px 32px"
      width="100%"
    >
      <TrialsPageHeader />

      <Box height="100%" mb="30px" {...centerPageViewContentStyles}>
        <Box flex="1 0 auto" height="100%">
          <Box
            color="#9ea9b8"
            fontSize="12px"
            fontWeight="500"
            lineHeight="24px"
            mb="16px"
          >{`Step ${stepCount} of ${TOTAL_STEPS}`}</Box>

          <Routes>
            <Route element={<TrialPayment />} path={TRIAL_PAYMENT_STEP} />
            <Route element={<TrialAccountInfo />} path="*" />
          </Routes>
        </Box>
      </Box>

      <TrialsPageFooter />
    </Flex>
  );
};

export default TrialPageView;
